import { render, staticRenderFns } from "./SupplyAlertDialog.vue?vue&type=template&id=110e6a30"
import script from "./SupplyAlertDialog.vue?vue&type=script&lang=ts"
export * from "./SupplyAlertDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports